import EventCounter from '../components/EventCounter';
import PageLayout from '../components/pageLayout';

function EventCounterPage() {
    return (
        <PageLayout children={<EventCounter />} />
    );
}

export default EventCounterPage;
